export type ReportErrorRequest = {
    message: string;
} & Record<string, any>;
